import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  ConfirmDialog,
} from '@shared/ui';

export function ConfirmDialogShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.confirmDialog.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.confirmDialog.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <ConfirmDialog
          title={t('uiLibrary.overlay.confirmDialog.modalTitle')}
          description={t('uiLibrary.overlay.confirmDialog.modalDescription')}
          confirmLabel={t('uiLibrary.overlay.confirmDialog.confirm')}
          cancelLabel={t('uiLibrary.overlay.confirmDialog.cancel')}
          onConfirm={() => undefined}
          trigger={
            <Button variant="destructive">{t('uiLibrary.overlay.confirmDialog.trigger')}</Button>
          }
        />
      </CardContent>
    </Card>
  );
}
